var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReportTable',{staticClass:"mt-4 pt-2 mb-5",attrs:{"title":"Alle Aanvragen","reports":_vm.reports}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }